/**
 * The angularjs states related to the module WhatsappTemplatesModule.
 */
messageTemplatesStates.$inject = ['$stateProvider'];
export function messageTemplatesStates($stateProvider) {

  $stateProvider
    .state('auth.alcmeon.fuse.parameters.message-templates', {
      url: '/message-templates?{type}',
      views: {
        'container@auth': {
          template: '<angular-message-templates></angular-message-templates>',
        }
      },
    })


    .state('auth.alcmeon.fuse.parameters.message-templates.whatsapp', {
      url: '/whatsapp',
      abstract: true,
    })
    .state('auth.alcmeon.fuse.parameters.message-templates.whatsapp.create', {
      url: '/template',
      views: {
        'container@auth': {
          template: '<angular-whatsapp-template [create]="true"></angular-whatsapp-template>',
        }
      },
    })
    .state('auth.alcmeon.fuse.parameters.message-templates.whatsapp.details', {
      url: '/:siteId/template/:templateElementName',
      views: {
        'container@auth': {
          template: '<angular-whatsapp-template></angular-whatsapp-template>',
        }
      },
    })


    .state('auth.alcmeon.fuse.parameters.message-templates.kakaotalk', {
      url: '/kakaotalk',
      abstract: true,
    })
    .state('auth.alcmeon.fuse.parameters.message-templates.kakaotalk.create', {
      url: '/template',
      views: {
        'container@auth': {
          template: '<angular-kakaotalk-template [create]="true"></angular-kakaotalk-template>',
        }
      },
    })
    .state('auth.alcmeon.fuse.parameters.message-templates.kakaotalk.details', {
      url: '/:siteId/template/:uuid',
      views: {
        'container@auth': {
          template: '<angular-kakaotalk-template></angular-kakaotalk-template>',
        }
      },
    })
    ;
}


